import { AbstractModel } from "../abstract-model";
import { MarketAirProductsModel } from "./market-air-products.model";
import { AirPackModel } from "./air-pack-model";
import { MinDTO } from "../min-dto";

export class AirModel extends AbstractModel {

    // TOTAL / DIMENSION
    uselbInch: boolean = false;
    // total / dimessions
    td: string = 'T';
    hideToolTip: boolean = false;


    // PACK
    totalWeight: number = null;
    totalVolume: number = null;
    cwg: number = null;
    pieces: number;
    stackable: boolean = true;
    flightDateType: string;
    flightDate: Date;
    departurePort: MinDTO;


    // PACKS
    packs: AirPackModel[] = [];

    calculatedPieces: number;

    // PRODUCT
    products: MarketAirProductsModel[] = [];
    selectedProduct: MarketAirProductsModel;

}
